export default __webpack_public_path__ + "static/corporate-websites-94ddfe0ddc7c0dd6a9aa1cff8558395a.png";